<template>
    <div class="viewContainer">
        <v-container>
            <v-row class="mb-5 mt-10">
                <v-col align-self="center" xs="12" offset-xs="0" sm="8" offset-sm="2" md="6" offset-md="3" lg="4"
                    offset-lg="4">
                    <v-card elevation="3" class="pa-6 text-center">
                        <v-icon color="warning" size="48">mdi-alert-circle-outline</v-icon>
                        <div class="headline mt-4 mb-2">{{ $t('account_not_verified') }}</div>
                        <v-card-text class="mt-2">
                            {{ $t('please_verify_your_email_to_continue') }}
                        </v-card-text>

                        <v-alert v-if="successMessage" type="success" class="mt-4">
                            {{ successMessage }}
                        </v-alert>
                        <v-alert v-if="errorMessage" type="error" class="mt-4">
                            {{ errorMessage }}
                        </v-alert>

                        <v-card-actions class="justify-center mt-2 flex-column">
                            <v-btn color="secondary" large :loading="loading" :disabled="loading || cooldown > 0"
                                @click="resend" class="mb-3">
                                {{ cooldown > 0 ? $t('resend_in', { seconds: cooldown }) :
                                    $t('resend_verification_email') }}
                            </v-btn>
                            <v-btn color="primary" large :to="{ name: 'login' }">
                                {{ $t('go_to_login') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'AccountNotVerified',
    data: () => ({
        loading: false,
        successMessage: '',
        errorMessage: '',
        cooldown: 0
    }),
    methods: {
        async resend() {
            console.log('email param:', this.$route.params.email)
            const email = this.$route.params.email
            if (!email) {
                this.errorMessage = this.$t('email_not_found_please_login_again')
                return
            }

            this.loading = true
            this.successMessage = ''
            this.errorMessage = ''

            try {
                await this.axios.post('/email/resend', { email })
                this.successMessage = this.$t('verification_email_resent')
                this.startCooldown()
            } catch (e) {
                this.errorMessage = this.$t('resend_error')
            } finally {
                this.loading = false
            }
        },
        startCooldown() {
            this.cooldown = 60
            const interval = setInterval(() => {
                this.cooldown--
                if (this.cooldown <= 0) clearInterval(interval)
            }, 1000)
        }
    }
}
</script>